import { Component, OnInit, Input } from '@angular/core';
import { EpDialogInstance, IEpDialogComponent, EpButtonStyle } from '@epicor/kinetic';

@Component({
  selector: 'epbt-fa-image-dialog',
  templateUrl: './epbt-fa-image-dialog.component.html',
  styleUrls: ['./epbt-fa-image-dialog.component.scss']
})
export class EpbtFaImageDialogComponent implements OnInit, IEpDialogComponent {
  EpButtonStyle = EpButtonStyle;

  instance: EpDialogInstance;
  imageData: any;
  constructor() { }

  ngOnInit() {
    this.imageData = this.instance.options.data;
  }
  onClickOk($event) {
    this.instance.close();
  }
  onClickCancel($event) {
    this.instance.close();
  }
}
